import React, { Component } from 'react';
import InputFieldComponent from './InputFieldComponent';
import { format } from 'redux-form-validators';
import { PHONENUMBER_REGEX } from './constants';

class PhoneInputFieldComponent extends Component {
    validateMandatory = () => [
        format({
            with: PHONENUMBER_REGEX,
            msg: this.props.i18nFeatureForm.PHONENUMBER_INVALID,
            allowBlank: !this.props.isRequired
        })
    ];

    render() {
        const { validate = [] } = this.props;
        return (
            <InputFieldComponent
                validate={[...this.validateMandatory(), ...validate]}
                type="tel"
                {...this.props}
            />
        );
    }
}

// See proptypes in ./InputFieldComponent.js

export default PhoneInputFieldComponent;



// WEBPACK FOOTER //
// ./src/components/form/PhoneInputFieldComponent.js